"use client";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
};
export const Wrapper = (props: Props) => {
	const pathname = usePathname();
	const isSuzuka2024 = pathname?.endsWith("events/suzuka2024/detail");
	const getBgColor = (): string => {
		if (isSuzuka2024)
			return "bg-[url('/events/suzuka2024/bg5.svg')] bg-repeat bg-suzuka2024";
		return "bg-white";
	};
	const getFontFamily = (): string => {
		if (isSuzuka2024) return "font-tsunagi";
		return "initial";
	};
	const getFontColor = (): string => {
		if (isSuzuka2024) return "text-suzuka2024naby";
		return "";
	};
	return (
		<div
			className={`flex justify-center ${getBgColor()} ${getFontFamily()} ${getFontColor()} `}
		>
			<div
				className={
					"flex flex-col gap-20 my-8 w-11/12 md:w-7/12 lg:w-7/12 max-w-[1200px]"
				}
			>
				{props.children}
			</div>
		</div>
	);
};
